import React from 'react'
import { createUseStyles } from 'react-jss'
import Carousel from 'react-multi-carousel'
import SVG from '../ui/SVG/SVG'
import { isClientSide } from '../ui/Common/utils'
import obj2Arr from '../../utils/obj2Arr'

const useStyles = createUseStyles(theme => ({
  containerT: {
    padding: '45px 0',
    margin: '0 auto',
    width: '100%',
    maxWidth: '1220px',
    '@media (max-width: 1200px)': {
      boxSizing: 'border-box',
      padding: '45px 15px',
    },
    '@media (max-width: 700px)': {
      boxSizing: 'border-box',
      padding: '45px 15px',
    },
  },
  TestimonialsCarousel: {
    width: '100%',
    margin: '0',

    '@media (max-width: 900px)': {
      margin: '35px 0',
    },

    '& .carousel .slide': {
      backgroundColor: 'transparent',
      textAlign: 'left',
    },
    '& .carousel.carousel-slider': {
      overflow: 'visible',
    },
    '& .carousel .control-dots': {
      bottom: '-38px',
      paddingLeft: 0,
    },
    '& .carousel .control-dots .dot': {
      backgroundColor: '#bbcad8',
      boxShadow: 'none',
      opacity: 0.7,
      transition: `background-color 250ms ${theme.animations.bezier}, opacity 250ms ${theme.animations.bezier}`,
    },
    '& .carousel .control-dots .dot.selected': {
      backgroundColor: theme.colors.blue,
      opacity: 1,
    },
    '& .carousel .control-dots .dot:hover': {
      backgroundColor: theme.colors.blue,
      opacity: 1,
    },
    '& .react-multi-carousel-dot button': {
      border: 'none !important',
      backgroundColor: '#DCDCDC !important',
      width: 10,
      height: 10,
      margin: '0 5px',
    },
    '& .react-multi-carousel-dot--active button': {
      border: 'none !important',
      backgroundColor: '#989898 !important',
      width: 10,
      height: 10,
      margin: '0 5px',
    },
  },
  testoContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    '@media (max-width: 600px)': {
      flexDirection: 'column',
    },
  },
  middleC: {
    maxWidth: 'calc(100% - 228px)',
    width: '100%',
    boxSizing: 'border-box',
    padding: '0 30px',
    '@media (max-width: 600px)': {
      maxWidth: '100%',
      width: '100%',
    },
    '& > div': {
      maxWidth: '675px',
      width: '100%',
      margin: '0 auto',
    },
  },
  RightQ: {
    flexGrow: 0,
    flexShrink: 1,
    width: 114,
    '& svg': {
      fill: '#AB206C',
      width: 114,
      height: 80,
      '@media (max-width: 600px)': {
        fill: '#007AC3',
        width: 92,
        height: 65,
      },
    },
  },
  LeftQ: {
    flexGrow: 0,
    flexShrink: 1,
    width: 114,
    '& svg': {
      fill: '#AB206C',
      width: 114,
      height: 80,
    },
    '@media (max-width: 600px)': {
      display: 'none !important',
    },
  },
  title: {
    color: '#2D2D2D',
    fontSize: '38px',
    lineHeight: '41px',
    fontWeight: 700,
    fontFamily: 'TTRounds',
    textAlign: 'center',
    paddingTop: '0',
    paddingBottom: '7px',
    marginBottom: '20px',
    '@media (max-width: 600px)': {
      fontSize: '24px',
      lineHeight: '29px',
    },
  },
  details: {
    color: '#2D2D2D',
    fontSize: '20px',
    lineHeight: '27px',
    fontWeight: 400,
    fontFamily: 'AvenirNextLTPro',
    textAlign: 'center',
    '@media (max-width: 600px)': {
      fontSize: '18px',
      lineHeight: '26px',
    },
  },
  name: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '50px',
    '& span:first-child': {
      display: 'inline-block',
      width: 7,
      height: 1,
      backgroundColor: '#2D2D2D',
      marginRight: 10,
    },
    '& span:nth-child(2)': {
      position: 'relative',
      color: '#2D2D2D',
      fontSize: '18px',
      lineHeight: '25px',
      fontWeight: 400,
      fontFamily: 'AvenirNextLTPro',
      '@media (max-width: 600px)': {
        fontSize: '17px',
        lineHeight: '23px',
      },
    },
  },
}))

const Testimonials = props => {
  const classes = useStyles()

  if (!props.items) return null

  const objArr = obj2Arr(props.items)

  if (objArr.length < 1) return null

  const responsive = {
    desktop: {
      breakpoint: { max: 4000, min: 1024 },
      items: 1,
    },
    desktopSmall: {
      breakpoint: { max: 1200, min: 1024 },
      items: 1,
    },
    tabletLandscape: {
      breakpoint: { max: 1024, min: 770 },
      items: 1,
    },
    tabletPortait: {
      breakpoint: { max: 769, min: 600 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 600, min: 0 },
      items: 1,
    },
  }

  return (
    <div style={{ backgroundColor: props.backgroundcolor }}>
      <div className={classes.containerT}>
        <div className={classes.testoContainer}>
          <div className={classes.RightQ}>
            <SVG name="RightQ" />
          </div>
          <div className={classes.middleC}>
            <div style={{ position: 'relative' }}>
              <Carousel
                className={classes.TestimonialsCarousel}
                deviceType={isClientSide() ? null : 'desktop'}
                infinite={objArr.length > 1}
                showDots={objArr.length > 1}
                autoPlay={objArr.length > 1}
                arrows={false}
                responsive={responsive}
                ssr={true}
                autoPlaySpeed={4000}
                renderButtonGroupOutside={false}
              >
                {objArr &&
                  objArr.map(section => (
                    <div key={section.title}>
                      <h3 className={classes.title}>{section.title}</h3>
                      <p className={classes.details}>{section.details}</p>
                      <div className={classes.name}>
                        <span />
                        <span>{section.name}</span>
                      </div>
                    </div>
                  ))}
              </Carousel>
            </div>
          </div>
          <div className={classes.LeftQ}>
            <SVG name="LeftQ" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Testimonials
